
const BarDataAPI = (response) => {

    var datos = []
    var categories = []
    var titulo = ''

    response.data.map(item => {
        datos.push(
            {
                y: item.valor,
                color: item.color
            }
        )
        categories.push(item.label)
        titulo = item.titulo;

    });

    //console.log({ datos: datos, categories: categories })

    return { titulo: titulo, datos: datos, categories: categories }
}

export default BarDataAPI




